module.exports = __webpack_public_path__ + "static/img/boat-6.215f706.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/boat-6.png
// module id = 7+Os
// module chunks = 0